import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { User } from '../models/user.model';
import { switchMap } from 'rxjs/operators';
import auth from 'firebase/app';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user$: Observable<any>;

  constructor(private afAuth: AngularFireAuth, private afs: AngularFirestore, private route: Router) {
    // Get the auth state, then fetch the Firestore user document or return null
    this.user$ = this.afAuth.authState.pipe(
      switchMap(user => {
        // Logged in
        if (user) {
          console.log("logged in");
          console.log(this.afAuth.user.subscribe(userdata => {
            console.log(userdata);
          }))
          return this.afs.doc<User>(`users/${user.uid}`).valueChanges();
        } else {
          // Logged out
          return of(null);
        }
      })
    );
  }

   /**
   * Opens popup, signs user into google account, and adds user data to firebase
   */
  async signIn(user) {
    this.updateUserData(user);
    this.route.navigate(['/profile']);
    return;
  }

  /**
   * adds user data to firebase after login
   * @param user -
   */
  private updateUserData(user) {
    // Sets user data to firestore on login
    const userRef = this.afs.firestore.doc(`users/${user.uid}`);

    const data = {
      uid: user.uid,
      email: user.email,
      address: user.address,
      phone: user.phone,
      name: user.name,
      state: user.state,
      role: user.role,
      country: user.country,
      attendance: user.attendance
    };

     //If user doesn't exist yet, set the user as a new document
    userRef.get().then((doc) => {
      if(!doc.exists){
        userRef.set(data, {merge: true});
      }
    })

  }
  //Sign Out Code
  async signOut() {
    await this.afAuth.signOut();
    this.route.navigate(['/']);
  }
}
